import { gql } from '@apollo/client';

export const AUTHENTICATION_ERROR_FRAGMENTS = gql`
  fragment AuthenticationErrorFields on AuthenticationError {
    code
    field
    message
  }
`;
